<template>
  <router-link to="/">
    <img
      v-if="isFleetPartnerOnly"
      class="for-light logo-size"
      src="../../assets/images/logo/logo-fleet-h-pos-sm.svg"
      alt="RYD"
    />
    <img
      v-else
      class="for-light logo-size"
      src="../../assets/images/logo/ryd-logo-colour.svg"
      alt="RYD"
    />
    <img
      v-if="isFleetPartnerOnly"
      class="for-dark logo-size"
      src="../../assets/images/logo/logo-fleet-h-pos-sm.svg"
      alt="RYD"
    />
    <img
      v-else
      class="for-dark logo-size"
      src="../../assets/images/logo/ryd-logo-colour.svg"
      alt="RYD"
    />
  </router-link>
</template>
<script setup>
defineProps({
  isFleetPartnerOnly: {
    type: Boolean,
    default: false,
  },
});
</script>

<style>

.logo-size {
  height: 40px
}

</style>
